import { cva, type VariantProps } from "class-variance-authority";

export const resultVariants = cva("text-wrap text-primary-800 font-bold", {
  variants: {
    size: {
      sm: "text-[0.875rem]",
      md: "text-base",
    },
  },
  defaultVariants: {
    size: "md",
  },
});

export const resultSubtitleVariants = cva("text-wrap text-center", {
  variants: {
    size: {
      sm: "text-[0.8125rem] text-urbix-gray-1000",
      md: "text-sm text-urbix-gray-1000",
    },
  },
  defaultVariants: {
    size: "md",
  },
});

export const assetVariants = cva("", {
  variants: {
    size: {
      sm: "w-[134px] h-[65px]",
      md: "w-[157px] h-[86px]",
    },
  },
  defaultVariants: {
    size: "md",
  },
});

export const assetIconVariants = cva("", {
  variants: {
    size: {
      sm: "w-[12px] h-[12px]",
      md: "w-[20px] h-[20px] ",
    },
    status: {
      success: "text-[#89D4B5]",
      error: "text-[#F18B95]",
      normal: "text-[#A786C6]",
    },
  },
  defaultVariants: {
    size: "md",
    status: "normal",
  },
});

export const assetIconPositionVariants = cva("absolute", {
  variants: {
    size: {
      sm: "bottom-[22px] right-[25px]",
      md: "bottom-[28px] right-[18px]",
    },
  },
  defaultVariants: {
    size: "md",
  },
});

export type ResultVariantsProps = VariantProps<typeof resultVariants>;
